export default {
    getProfessors: { method: 'get', url: 'api/secure/professor'},
    getAllProfessors: { method: 'get', url: 'api/secure/professor/list'}}